module.exports = "<div class='sub_title'>\n  대표 소개\n</div>\n\n<img src=\"assets/page/ceo.jpg\" style='width:100%;'>\n"